import 'shared/registry.js';
import { _converse } from '@converse/headless/core';
// ImageModal is not getting called directly, but it is used for "converse-image-modal"
import ImageModal from 'shared/modals/image.js';
import renderRichText from 'shared/directives/rich-text.js';
import { CustomElement } from 'shared/components/element.js';
import { api } from "@converse/headless/core";
import { getAppSettings } from '@converse/headless/shared/settings/utils.js';
import { html } from 'lit';

import './styles/message-body.scss';


export default class MessageBody extends CustomElement {

    static get properties () {
        return {
            // We make this a string instead of a boolean, since we want to
            // distinguish between true, false and undefined states
            hide_url_previews: { type: String },
            is_me_message: { type: Boolean },
            model: { type: Object },
            text: { type: String },
            postData: { type: Object },
            eventData: { type: Object }
        }
    }

    postData = null
    eventData = null

    initialize () {
        const settings = getAppSettings();
        this.listenTo(settings, 'change:allowed_audio_domains', () => this.requestUpdate());
        this.listenTo(settings, 'change:allowed_image_domains', () => this.requestUpdate());
        this.listenTo(settings, 'change:allowed_video_domains', () => this.requestUpdate());
        this.listenTo(settings, 'change:render_media', () => this.requestUpdate());
    }

    updated(changedProps) {
        let credentials = JSON.parse(localStorage.getItem('credentials'))
        if (changedProps.has('text') && this.text?.startsWith(window.location.origin + '/?post-id=')) {
            const postIdParam = new URL(this.text).searchParams.get('post-id')

            if (!isNaN(postIdParam) && Number.isInteger(Number(postIdParam))) {
                const formData = new FormData()
                formData.append('type', 'blogPreview')
                formData.append('postId', postIdParam)

                fetch(window.converseEnv.reactAppApiUrl + '/posts', {
                    method: 'POST',
                    body: formData
                })
                .then(response => response.json())
                .then(data => {
                    this.postData = { ...data['posts'][0] }
                    this.requestUpdate()
                })
                .catch(err => console.error('Fetch error:', err))
            }
        }
        else if (changedProps.has('text') && this.text?.startsWith(window.location.origin + '/?eventid=')) {
            const eventIdParam = new URL(this.text).searchParams.get('eventid')

            if (!isNaN(eventIdParam) && Number.isInteger(Number(eventIdParam))) {
                const formData = new FormData()
                formData.append('id', eventIdParam)
                const data = {
                    id: eventIdParam
                }

                fetch(window.converseEnv.reactAppApiUrl + '/event/single', {
                    method: 'POST',
                    headers:{
                        'Access-Token': 'Bearer ' + credentials.access_token,
                        'Authorization': 'Bearer ' + credentials.access_token,
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Allow-Credentials': true,
                        'Access-Control-Allow-Headers': '*',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(data)
                })
                .then(response => response.json())
                .then(data => {
                    this.eventData = { ...data['events'][0] }
                    this.requestUpdate()
                })
                .catch(err => console.error('Fetch error:', err))
            }
        }
    }

    onImgClick (ev) { // eslint-disable-line class-methods-use-this
        ev.preventDefault();
        api.modal.remove('converse-image-modal');
        api.modal.show('converse-image-modal', {'src': ev.target.src}, ev);
    }

    onImgLoad () {
        this.dispatchEvent(new CustomEvent('imageLoaded', { detail: this, 'bubbles': true }));
    }

    render () {
        if (this.postData) {
            if (Object.keys(this.postData).length && !this.postData?.name) {    
                const date = new Date(this.postData.created_at)
                const formattedDate = date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                })
                const defaultAvatar = 'data:' + _converse.DEFAULT_IMAGE_TYPE + ';base64,' + _converse.DEFAULT_IMAGE

                return html`<div class="custom-blog-preview"><div class="custom-blog-preview-headline"><img class="blog-author-image" src="${this.postData.profile_picture ?? defaultAvatar}" alt="blog Image"><div class="blog-title">${this.postData.title}</div></div><div class="blog-info"><p class="blog-profile-name">${this.postData.full_name}</p><p class="blog-published-date">${formattedDate}</p></div></div>`
            }else {
                return html`<div class="custom-blog-preview"><div class="custom-blog-preview-headline" style="grid-template-columns:auto;padding-right:0;gap:0;margin-top:5px"><div class="blog-title">Post was removed or unavailable</div></div></div>`
            }
        }
        if (this.eventData) {
            if (Object.keys(this.eventData).length) {
                const MonthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
                const start_date = new Date(this.eventData?.start_date + 'Z')
                const end_date = new Date(this.eventData?.end_date + 'Z')
                const start_date_convert = new Date(start_date.toLocaleString('en-US', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }))
                const end_date_convert = new Date(end_date.toLocaleString('en-US', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }))
                const month1 = MonthName[start_date_convert.getMonth()]
                const month2 = MonthName[end_date_convert.getMonth()]
                const day1 = start_date_convert.getDate()
                const day2 = end_date_convert.getDate()
                const daterange = month1 + ' ' + day1 + ' - ' + month2 + ' ' + day2

                return html`<div class="custom-event-preview"><div class="custom-event-preview-name" style="background-image:url('${this.eventData.background_image}')"><div class="event-title">${this.eventData.name}</div></div><div class="custom-event-preview-date"><p class="event-date">${daterange}</p></div></div>`
            } else {
                return html`<div class="custom-blog-preview"><div class="custom-blog-preview-headline" style="grid-template-columns:auto;padding-right:0;gap:0;margin-top:5px"><div class="blog-title">Event was removed or unavailable</div></div></div>`
            }
        }
         

        if(this.text?.startsWith(window.location.origin + '/?eventid=')) {
            return html`<div class="custom-event-preview"><div class="custom-event-preview-name"><div class="event-title event-skeleton"><span class="event-skeleton-placeholder">Food Fight at Waffle House</span></div></div><div class="custom-event-preview-date"><div class="event-date event-skeleton"><span class="event-skeleton-placeholder">Jan 30 - Feb 3</span></div></div></div>`
        }

        if (this.text?.startsWith(window.location.origin + '/?post-id=')) {
            return html`<div class="custom-blog-preview"><div class="custom-blog-preview-headline"><div class="blog-author-image skeleton"></div><div class="blog-title skeleton"><span class="skeleton-placeholder">My dad's 1965 Plymouth Fury Hardtop</span></div></div><div class="blog-info"><p class="blog-profile-name skeleton"><span class="skeleton-placeholder">Virginia Slim</span></p><p class="blog-published-date skeleton"><span class="skeleton-placeholder">Jan 20, 2025</span></p></div></div>`
        }

        const idUrlRegex = new RegExp(`${window.location.origin}/\\?id=(\\d+)`, 'g')
        const anyUrlRegex = /https?:\/\/[^\s]+/g

        // This is to ensure that uploaded images through chat will load as image
        if (
            this.text?.includes('http')
            && !this.text?.startsWith('https://x.connector.app:5443')
            && !this.text?.startsWith('https://dat01.turnkeywebstores.biz:5443')
        ) {
            const parts = []
            let lastIndex = 0
            let match

            while ((match = anyUrlRegex.exec(this.text)) !== null) {
                const url = match[0]

                if (match.index > lastIndex) {
                    parts.push(this.text.slice(lastIndex, match.index))
                }

                const idMatch = url.match(idUrlRegex)
                if (idMatch) {
                    const id = idMatch[0].split('/?id=')[1]
                    parts.push(html`<a href="${url}" rel="noopener" @click="${(ev) => {
                                ev.preventDefault()
                                ev.stopPropagation()

                                const event = new CustomEvent('custom-chat-show_on_map', {
                                    detail: { jid: id + '-' }
                                })
                                window.dispatchEvent(event)
                            }}">${url}</a>`)
                } else {
                    parts.push(html`<a href="${url}" rel="noopener" target="_blank">${url}</a>`)
                }

                lastIndex = match.index + url.length
            }

            if (lastIndex < this.text.length) {
                parts.push(this.text.slice(lastIndex))
            }

            return html`${parts}`
        }

        const callback = () => this.model.collection?.trigger('rendered', this.model);
        const offset = 0;
        const options = {
            'media_urls': this.model.get('media_urls'),
            'mentions': this.model.get('references'),
            'nick': this.model.collection.chatbox.get('nick'),
            'onImgClick': (ev) => this.onImgClick(ev),
            'onImgLoad': () => this.onImgLoad(),
            'render_styling': !this.model.get('is_unstyled') && api.settings.get('allow_message_styling'),
            'show_me_message': true,
            'hide_media_urls': true
        }
        if (this.hide_url_previews === "false") {
            options.embed_audio = true;
            options.embed_videos = true;
            options.show_images = true;
        } else if (this.hide_url_previews === "true") {
            options.embed_audio = false;
            options.embed_videos = false;
            options.show_images = false;
        }
        return renderRichText(this.text, offset, options, callback);
    }
}

api.elements.define('converse-chat-message-body', MessageBody);
